// eslint-disable-next-line import/prefer-default-export
export enum OcrType {
    vrn = 'vrn', // For vehicle number plate
    dashboard = 'dashboard', // For vehicle odo and soc dashboard
}
